import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-[#0a0b0e] border border-[#262a33] rounded-xl px-4 py-3 text-white placeholder:text-[#64697a] outline-none focus:ring-2 focus:ring-[#00e676] transition-colors";

  return (
    <div className="min-h-screen bg-[#0a0b0e] flex items-center justify-center px-5 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-10"
        style={{ backgroundImage: "url(https://images.unsplash.com/photo-1669882571612-4a9c7822cd4c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200)", backgroundSize: "cover", backgroundPosition: "center" }}
      />
      <div className="relative w-full max-w-sm bg-[#161920] border border-[#262a33] rounded-2xl p-7 fade-up">
        <div className="flex flex-col items-center text-center mb-6">
          <div className="w-12 h-12 rounded-xl bg-[#00e676]/10 flex items-center justify-center mb-3">
            <ShieldCheck className="w-6 h-6 text-[#00e676]" />
          </div>
          <h1 className="font-display text-2xl font-extrabold text-white">Administration CC Auto 30</h1>
          <p className="text-[#64697a] text-sm">Gestion des avis clients</p>
        </div>

        <form onSubmit={submit} className="flex flex-col gap-4">
          <input type="email" placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="login-email" />
          <input type="password" placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="login-password" />
          {error && <p className="text-red-400 text-sm" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} className="w-full bg-[#00e676] hover:bg-[#00c853] text-[#04120a] font-bold rounded-full py-3 flex items-center justify-center gap-2 transition-colors disabled:opacity-60" data-testid="login-submit">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Se connecter"}
          </button>
          <Link to="/admin/forgot-password" className="text-center text-sm text-[#a0a5b5] hover:text-white transition-colors" data-testid="forgot-link">
            Mot de passe oublié ?
          </Link>
        </form>
      </div>
    </div>
  );
}
